import {useAccountQuery} from '../api/generated';
import {config} from '../stage.config';

export const useHostedPaymentDomain = (skip: boolean, accountId: string) => {
  const {data} = useAccountQuery({skip, variables: {id: accountId as string}});
  const account = data?.account;
  if (account?.customDomain) {
    return account.customDomain;
  }
  return config.hostedPaymentDomain;
};
